import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-autopilot-in",
  "use": "icon-soc-autopilot-in-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-autopilot-in\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"512\" cy=\"512\" r=\"320\" fill-opacity=\".25\" /><circle cx=\"512\" cy=\"512\" r=\"200\" fill-opacity=\".4\" /><circle cx=\"512\" cy=\"512\" r=\"64\" /><path d=\"M512 512l224-224h64L512 512z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-autopilot-in.svg
// module id = 9vI6
// module chunks = 534